import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './TableCellMultiIcons.css';
import Tooltip from '../molecules/Tooltip';

const TableCellMultiIcons = ({ icons = [], className = '', tooltips = [], rowIndex }) => {
    return (
        <td>
            <div key={`multi-icon-${rowIndex}`} className={classNames(css.TableCellMultiIcons, className)}>
                {icons.map((Icon, index) => (
                    <Tooltip
                        distance={6}
                        // eslint-disable-next-line react/no-array-index-key
                        key={`icon-${rowIndex}-${index}`}
                        disabled={!tooltips[index]}
                        title={tooltips[index]}
                    >
                        {typeof Icon === 'string' ? (
                            <img src={Icon} alt={`icon-${rowIndex}-${index}`} className={css.imageIcon} />
                        ) : (
                            <Icon className={css.multiIcon} />
                        )}
                    </Tooltip>
                ))}
            </div>
        </td>
    );
};

TableCellMultiIcons.propTypes = {
    icons: PropTypes.arrayOf(PropTypes.any),
    className: PropTypes.string,
    tooltips: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string])),
    rowIndex: PropTypes.number,
};

export default TableCellMultiIcons;
